import { makeStyles } from "@material-ui/core";
import ButtonBase from "@material-ui/core/ButtonBase";
import React from "react";
import { CustomButtonProps } from "./CustomButton";

interface CustomButtonTextProps extends CustomButtonProps {
  label: string;
  color?: string;
}

const useStyles = makeStyles(() => {
  return {
    root: (props: CustomButtonTextProps) => ({
      color: props.color,
      fontFamily: "Proxima Nova Bold",
    }),
  };
});

const CustomButtonText = (props: CustomButtonTextProps) => {
  const { className, label, onMouseDown } = props;
  const classes = useStyles(props);

  return (
    <ButtonBase className={[classes.root, className].join(" ")} onMouseDown={onMouseDown}>
      {label}
    </ButtonBase>
  );
};

export default CustomButtonText;
